import VueRouter, { Route } from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import { USER_REQUIRES_TERMS_ACCEPTANCE_QUERY } from '@gig/magic-messages';

export function initConsentRequiredGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        if (!(await hasPendingConsents())) {
            next();
            return;
        }

        if (!isConsentRequired(to)) {
            next();
        } else {
            next({ name: RouteName.HOME });
        }
    });
}

function hasPendingConsents() {
    return window.queryBus.query<boolean>(USER_REQUIRES_TERMS_ACCEPTANCE_QUERY);
}

export function isConsentRequired(route: Route) {
    return !route.matched.some(({ meta }) => meta.pendingConsentsAllowed);
}

export function isUpdatedTermsPromptHidden(route: Route) {
    return route.matched.some(({ meta }) => meta.hideUpdatedTermsPrompt);
}

export function allowWithPendingConsents(
    hideUpdatedTermsPrompt: boolean = false,
) {
    return {
        pendingConsentsAllowed: true,
        hideUpdatedTermsPrompt,
    };
}
